import { FC, useCallback, useContext, useEffect } from "react";
import confetti from "canvas-confetti";

import { SocketContext, TeamContext } from "../../../../context";
import { useSound } from "../../../../hooks";
import { Phase } from "../../../../util/enums";
interface CustomHTMLElement extends HTMLCanvasElement {
  	confetti: any;
}

const CheerButton: FC<{}> = () => {
	const { game } = useContext(TeamContext);
	const { socket, triggerConfetti, playCheeringSound } = useContext(SocketContext);

	const buttonDisabled = !(game?.phase === Phase.CONFETTI_CELEBRATION);
	const {playSound} = useSound();

	let soundList = [
		"/sounds/Yay.mp3",
		"/sounds/Whoppii.mp3",
		"/sounds/AudienceCheering.mp3",
		"/sounds/claps.mp3",
		"/sounds/bell.mp3",
	];

	const addConfetti = useCallback(() => {
		const htmlCanvas = document.getElementById("confeti-random") as CustomHTMLElement;

		htmlCanvas!.confetti =
		htmlCanvas!.confetti || confetti.create(htmlCanvas, { resize: true });
		htmlCanvas!.confetti({
		particleCount: randomInRange(50, 100),
		origin: randomInRange({ y: 1 }, { x: 1 }),
		angle: randomInRange(55, 125),
		spread: randomInRange(50, 70),
		gravity: randomInRange(0.2, 3),
		zIndex: 100,
		startVelocity: 50,
		scalar: randomInRange(1, 3),
		colors: ["#53BD8B", "#FF00A7", "#005776", "#FED100"],
		resize: true,
		});
	}, []);

	const randomInRange = (min: any, max: any) => {
		return Math.random() * (max - min) + min;
	};

	const getRandomSound = () => {
		return soundList[Math.floor(Math.random() * soundList.length)];
	};

	const handleClick = () => {
		if (!buttonDisabled) {
			triggerConfetti();
			playCheeringSound(getRandomSound());
		}
	};

	const buttonStatus = () => {
		if (buttonDisabled === true) 
			return "cheer_button__disabled";
		
		return "cheer_button";
	};

	useEffect(() => {	
		socket?.on("celebrate", () => {
			addConfetti();
		});

		return () => {
			socket?.off("celebrate");

		}
	}, [addConfetti, socket]);

	useEffect(() => {
		if((game?.gameInfo?.challengeScore as any) >= 4){
		socket?.on("playSound", (sound) => {
			playSound(sound);
		});

		return () => {
			socket?.off("playSound");
		};
	};

	}, [playSound, socket]);

	return (
		<div className={buttonStatus()} onClick={handleClick} style={{ zIndex: 110 }} >
			<div className="cheer_button__icon" />
		</div>
	);
};

export default CheerButton;
